import { Form } from '@/components';
import { CreateTaskGroupArgs } from '@/redux';
import { Button, Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { useTaskGroupsLookupSource } from './useTaskGroupsLookupSource';

interface BulkUpdateTaskModalProps {
  taskIds: string[];
  projectId: string;
  onSubmit: (value: CreateTaskGroupArgs) => any;
  onClose: () => any;
}

const INITIAL_VALUES: CreateTaskGroupArgs = {
  name: null!,
  taskIds: [],
};

const schema = Yup.object().shape({
  name: Yup.string().field().nullable().required(),
});

export function CreateTaskGroupModal(props: BulkUpdateTaskModalProps) {
  const { onClose, onSubmit, taskIds, projectId } = props;
  const { t } = useTranslation();

  const handleSubmit = (value: CreateTaskGroupArgs) => {
    onSubmit({ taskIds, projectId, name: value.name });
  };

  const taskGroupsOptionSource = useTaskGroupsLookupSource(projectId);

  return (
    <Modal
      title={t('tasks.groups.createModalTitle')}
      visible
      onCancel={onClose}
      footer={[
        <Button key="back" type="default" onClick={onClose}>
          {t('cancel')}
        </Button>,
        <Form.Submit uid="create-task-group" key="submit" type="primary">
          {t('save')}
        </Form.Submit>,
      ]}
    >
      <Form.Formik<CreateTaskGroupArgs>
        uid="create-task-group"
        i18n="tasks.groups"
        initialValues={INITIAL_VALUES}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        <Form.CreatableAsyncSelect
          dataSource={taskGroupsOptionSource}
          name="name"
        />
      </Form.Formik>
    </Modal>
  );
}
